module.exports = __webpack_public_path__ + "static/media/photo-9-m.08b9a1d2.jpeg";